<template>
  <sui-segment>
	  <v-row>
		<v-col cols="20">
<v-card
    class="mx-auto text-center"
    color="green"
    dark
    max-width="600"
  >
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
      <v-sparkline
        :labels="sparkLablesWeek"
        :value="sparkValuesWeek"
        color="white"
		smooth
        line-width="2"
        padding="16"
      ></v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="text-h4 font-weight-thin">
        {{$t("salesLastWeek")}}
      </div>
    </v-card-text>

    <v-divider></v-divider>
  </v-card>
  </v-col>
	<v-col cols="20">
<v-card
    class="mx-auto text-center"
    color="green"
    dark
    max-width="600"
  >
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
      <v-sparkline
        :labels="sparkLablesMonth"
        :value="sparkValuesMonth"
        color="white"
		smooth
        line-width="2"
        padding="16"
      ></v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="text-h4 font-weight-thin">
        {{$t("salesLastMonth")}}
      </div>
    </v-card-text>

    <v-divider></v-divider>
  </v-card>
  </v-col>
</v-row>
<br>
<v-row>
  <v-col>
    <v-card>
<v-row>
  <v-col>
      {{$t("totalCheckouts")}}: {{stats.totalCheckouts}}
  </v-col>
  <v-col>
      {{$t("totalMoney")}}: {{ new Intl.NumberFormat("de-DE", { style: "currency",  currency: "EUR",  }).format(stats.totalMoney)}}
  </v-col>
  <v-col>
      {{$t("totalAmount")}}: {{stats.totalAmount}}
  </v-col>
</v-row>
<v-row>
  <v-col>
      {{$t("totalLastWeek")}}: {{stats.totalLastWeek}}
  </v-col>
  <v-col></v-col>
  <v-col>
      {{$t("lastWeekMoney")}}: {{ new Intl.NumberFormat("de-DE", { style: "currency",  currency: "EUR",  }).format(stats.lastWeekMoney)}}
  </v-col>
</v-row>
    </v-card>
  </v-col>
</v-row>
  </sui-segment>
</template>

<script>
import ApiService from "@/services/ApiService.js";
export default {
	data() {
		return {
			stats: {},
			sparkLablesWeek: [],
			sparkValuesWeek: [],
			sparkLablesMonth: [],
			sparkValuesMonth: [],
		}
	},
	async created(){
		this.renderContent()
	},
	methods: {
		async renderContent(){
			let res = await ApiService.getStats();
			if(res.status == 200) {
				this.stats = res.data
				this.stats.weekDayMoney.forEach(el => {

					let date = new Date(el.day);

					let week = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];
					this.sparkLablesWeek.push(this.$t(week[date.getDay()] + "Weekday"))
					this.sparkValuesWeek.push(el.money)
				});
				this.stats.monthMoney.forEach(el => {

					let date = new Date(el.day);

					// let week = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];
					this.sparkLablesMonth.push(date.getDate())
					this.sparkValuesMonth.push(el.money)
				});
			}
		}
	}


}
</script>

<style>
</style>